"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BikeStationDialog = BikeStationDialog;
var _DialogTitle2 = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _Dialog2 = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogActions2 = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _bikeStationAvailabilities = _interopRequireDefault(require("./bike-station-availabilities"));
var _bikeStationHistoryChart = _interopRequireDefault(require("./bike-station-history-chart"));
var _button = require("./button");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function BikeStationDialog({
  search,
  bikeStation: _bikeStation,
  onUpdated,
  onSearchUpdated,
  ...props
}) {
  const [bikeStation, setBikeStation] = (0, _react.useState)(_bikeStation);
  const [history, setHistory] = (0, _react.useState)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  (0, _react.useEffect)(() => {
    setBikeStation(_bikeStation);
  }, [_bikeStation]);
  function handleLeaveFromHere() {
    if (!bikeStation) return;
    search?.wayPoints.splice(0, 1, bikeStation.location.clone());
    onSearchUpdated?.();
  }
  function handleGoThere() {
    if (!bikeStation) return;
    search?.wayPoints.splice(-1, 1, bikeStation.location.clone());
    onSearchUpdated?.();
  }
  return /*#__PURE__*/_react.default.createElement(_Dialog2.default, _extends({
    fullWidth: true,
    maxWidth: "md"
  }, props), /*#__PURE__*/_react.default.createElement(StyledDialogTitle, null, bikeStation?.label || '', /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, bikeStation?.location.address)), /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => props.onClose(),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, bikeStation && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_bikeStationAvailabilities.default, {
    bikeStation: bikeStation,
    enqueueSnackbar: enqueueSnackbar,
    onUpdated: onUpdated,
    setBikeStation: setBikeStation,
    setHistory: setHistory
  }), /*#__PURE__*/_react.default.createElement(_bikeStationHistoryChart.default, {
    bikeStation: bikeStation,
    history: history
  }))), search && /*#__PURE__*/_react.default.createElement(_DialogActions2.default, null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "inherit",
    onClick: handleLeaveFromHere,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.leave_from_here"
  })), /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "inherit",
    onClick: handleGoThere,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.go_there"
  }))));
}
const StyledDialogTitle = (0, _styledComponents.styled)(_DialogTitle2.default)`
  && {
    padding-right: 46px;
  }
`;
const CloseButtonWrapper = _styledComponents.styled.div`
  position: absolute;
  right: 8px;
  top: 8px;

  button {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;